var _a, _b;
import { __decorate, __metadata, __param } from "tslib";
import { inject, injectable } from '@patsnap/tahiti-core/shared/inversify';
import { EnvConfig } from '@/domains/base/types/env-config.interface';
import { PsHttp } from '@patsnap/tahiti-core/common/ps-http';
let CategoryApiImpl = class CategoryApiImpl {
    constructor(_envConfig, _psHttp) {
        this._envConfig = _envConfig;
        this._psHttp = _psHttp;
    }
    _baseUrl(workspaceId, folderId) {
        return `${this._envConfig.WORKSPACE_SERVICE_URI}/workspace/web/${workspaceId}/folder/${folderId}/tech-tree`;
    }
    checkCache(workspaceId, folderId) {
        return this._psHttp({
            url: `${this._baseUrl(workspaceId, folderId)}/result`,
            method: 'GET',
            params: { include_patent_list: true },
            transformCode: true,
        }).then(({ data }) => data.data);
    }
    submitTask(workspaceId, folderId) {
        return this._psHttp({
            url: `${this._baseUrl(workspaceId, folderId)}/submit`,
            method: 'POST',
            transformCode: true,
        }).then(({ data }) => data.data);
    }
    pollResult(workspaceId, folderId) {
        return this._psHttp({
            url: `${this._baseUrl(workspaceId, folderId)}/result`,
            method: 'GET',
            transformCode: true,
        }).then(({ data }) => data.data);
    }
};
CategoryApiImpl = __decorate([
    injectable(),
    __param(0, inject(EnvConfig)),
    __param(1, inject(PsHttp)),
    __metadata("design:paramtypes", [typeof (_a = typeof EnvConfig !== "undefined" && EnvConfig) === "function" ? _a : Object, typeof (_b = typeof PsHttp !== "undefined" && PsHttp) === "function" ? _b : Object])
], CategoryApiImpl);
export { CategoryApiImpl };
